import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "" }
const _hoisted_3 = { class: "offset-md-3 card col-md-5" }
const _hoisted_4 = { class: "card-body flex-center" }
const _hoisted_5 = { class: "form-group has-feedback" }
const _hoisted_6 = { class: "input-group" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "input-group-prepend" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "input-group-text no-color",
    id: "btnGroupAddon"
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fa fa-envelope-o fa-fw" })
  ])
], -1)
const _hoisted_8 = { class: "form-group has-feedback" }
const _hoisted_9 = { class: "input-group has-feedback" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "input-group-prepend" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "input-group-text no-color",
    id: "btnGroupAddon"
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fa fa-lock fa-fw" })
  ])
], -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("button", {
  type: "submit",
  class: "btn btn-block btn-success"
}, "Log in", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  viewBox: "0 0 32 32",
  width: "24",
  height: "24"
}, [
  /*#__PURE__*/_createElementVNode("defs", null, [
    /*#__PURE__*/_createElementVNode("path", {
      id: "A",
      d: "M44.5 20H24v8.5h11.8C34.7 33.9 30.1 37 24 37c-7.2 0-13-5.8-13-13s5.8-13 13-13c3.1 0 5.9 1.1 8.1 2.9l6.4-6.4C34.6 4.1 29.6 2 24 2 11.8 2 2 11.8 2 24s9.8 22 22 22c11 0 21-8 21-22 0-1.3-.2-2.7-.5-4z"
    })
  ]),
  /*#__PURE__*/_createElementVNode("clipPath", { id: "B" }, [
    /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#A" })
  ]),
  /*#__PURE__*/_createElementVNode("g", { transform: "matrix(.727273 0 0 .727273 -.954545 -1.45455)" }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M0 37V11l17 13z",
      "clip-path": "url(#B)",
      fill: "#fbbc05"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M0 11l17 13 7-6.1L48 14V0H0z",
      "clip-path": "url(#B)",
      fill: "#ea4335"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M0 37l30-23 7.9 1L48 0v48H0z",
      "clip-path": "url(#B)",
      fill: "#34a853"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M48 48L17 24l-4-3 35-10z",
      "clip-path": "url(#B)",
      fill: "#4285f4"
    })
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_ctx.isDev())
            ? (_openBlock(), _createElementBlock("form", {
                key: 0,
                role: "form",
                class: "flex-center",
                onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)), ["prevent"]))
              }, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _hoisted_7,
                    _withDirectives(_createElementVNode("input", {
                      class: "form-control input-lg text-black",
                      type: "text",
                      name: "email",
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.email) = $event)),
                      placeholder: "Email",
                      required: "",
                      autofocus: ""
                    }, null, 512), [
                      [_vModelText, _ctx.email]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _hoisted_10,
                    _withDirectives(_createElementVNode("input", {
                      class: "form-control input-lg text-black",
                      type: "password",
                      name: "password",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.password) = $event)),
                      placeholder: "Password",
                      required: ""
                    }, null, 512), [
                      [_vModelText, _ctx.password]
                    ])
                  ])
                ]),
                _hoisted_11,
                _hoisted_12
              ], 32))
            : _createCommentVNode("", true),
          _createElementVNode("button", {
            class: "btn btn-block py-1 px-3 btn-social text-black btn-google bg-white flex-center gap-2",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.authOpen('google')))
          }, [
            _createTextVNode(" Sign in with "),
            _hoisted_13
          ])
        ])
      ])
    ])
  ]))
}